const API_URL = 'https://sistema.yacopini.com.ar/intranet/webservice/v2/nissan';

const INTERNAL_API_URL =
  process.env.REACT_APP_INTERNAL_API_URL ||
  'https://territorioyacopini.com.ar/api/v2/nissan';

export { API_URL, INTERNAL_API_URL };
